"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../styles/ProductFoundComponent.css");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const ProductFoundComponent = _ref => {
  let {
    productFoundContent,
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    partNumberInputDisabled,
    partNumberPlaceholder,
    onchange,
    continueBtnTitle,
    productFoundCont,
    continueBtnDisabled,
    id,
    productImage,
    partNumberInputValue,
    inputLabel,
    isLoading,
    noProductImage
  } = _ref;
  return isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "product-found-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product-found-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product-content-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-found-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, productFoundContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(noProductImage ? "product-found-centerImg" : "product-notfound-centerImg")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: productImage,
    alt: "device"
  }), !noProductImage ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginTop: "10px"
    }
  }, "No product image to show") : null), noProductImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "product-found-input",
    "data-testid": "partnuminput"
  }, /*#__PURE__*/_react.default.createElement("label", null, inputLabel), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: partNumberInputDisabled,
    value: partNumberInputValue,
    placeholder: partNumberPlaceholder,
    onchange: e => onchange(id, e.target.value)
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "product-found-conti-btn",
    "data-testid": "product-found-cont-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: continueBtnTitle,
    onClick: productFoundCont,
    disabled: continueBtnDisabled
  })))));
};
var _default = exports.default = ProductFoundComponent;